module.exports = "/_next/static/images/e2066cdda551996042a945652a587dc4-woman-holding-card-smiling@2x.jpg";